import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
//import { SpecialityService } from 'src/app/_services/speciality.service';
import { SpecialityService } from './../../_services/speciality.service';

import {MatSnackBar} from '@angular/material';
import { OrganisationsService } from 'app/_services/organisations.service';

@Component({
  selector: 'app-addeditspeciality',
  templateUrl: './addeditspeciality.component.html',
  styleUrls: ['./addeditspeciality.component.css']
})
export class AddeditspecialityComponent implements OnInit {

  orgtypeselectedValue:any
  speciality: any =
  {
  utoken:localStorage.getItem("utoken"),
  usermasterid:localStorage.getItem("user_master_id"),
  speciality_id: 0,
  speciality_name: '',
  speciality_for:'',
  status: 'Active'
  };

  productLoading:Boolean=false
  errorMessage: string;
  submitted = false;
  organizationType:any
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar:MatSnackBar,
    private specialityservice:SpecialityService,
    private orgservice: OrganisationsService,
  ){

  }

  ngOnInit() {

    console.log("ssssssssss")

    this.getOrganizationType()

    this.route.params.subscribe(
      params => {
      if(this.route.snapshot.params.speciality_id){
        this.specialityservice.geteditspecialitydata(this.route.snapshot.params.speciality_id)
        .subscribe(
        data => {
          this.speciality.speciality_id = data.Data[0].speciality_id
          this.speciality.speciality_name = data.Data[0].speciality_name
      

          console.log("data.Data[0].speciality_for",data.Data[0].speciality_for)
          if(data.Data[0].speciality_for!="0")
          {
          this.speciality.speciality_for = data.Data[0].speciality_for
          }
          this.speciality.status = data.Data[0].status


          this.orgtypeselectedValue=this.speciality.speciality_fo

console.log("this.speciality.speciality_fo",this.speciality.speciality_fo)

          //console.log("speciality",data)
        })
      }
    })
  }

 

  onSubmit(){
    this.submitted = true;

    this.productLoading=true
    console.log("this.speciality",this.speciality)

    this.specialityservice.createspeciality(this.speciality).subscribe(data => {
      if(data.status_code==200){

        this.productLoading=false

         this.snackbar.open(data.Metadata.Message, '', {
        duration: 3000,
        verticalPosition:"top",
        extraClasses: ['bg-green']
      });

        this.router.navigate(['/speciality']);


      }else{
        this.productLoading=false
      
      
      
 this.snackbar.open(data.Metadata.Message, '', {
  duration: 3000,
  verticalPosition:"top",
  extraClasses: ['bg-red']
}); 
      
      
      }
    })
  }

 /* 09-04-2019 */
 getOrganizationType(){
  this.orgservice.getOrganizationTypeActive().subscribe((response)=>{

console.log("response.Data",response.Data)

      this.organizationType = response.Data
  })
}
/* 09-04-2019 */

}



// WEBPACK FOOTER //
// ./src/app/component/addeditspeciality/addeditspeciality.component.ts